import { t } from 'i18next';
import { sdk } from 'utils/query';
import { CallBackProps } from 'models/general';
import { useCustomMutation } from '../useCustomMutation';

interface UpdatePasswordProps {
  oldPassword: string;
  newPassword: string;
}

const updatePassword = (props: UpdatePasswordProps) => {
  return sdk.users.changePassword(props);
};

export const useUpdatePassword = ({ callback }: CallBackProps) => {
  return useCustomMutation({
    fn: updatePassword,
    onSuccess: {
      message: t('success_data_updated', { value: t('personal_data_label') }),
      callback,
    },
  });
};
